<template lang="pug">
  .finance-account
    .card
      .header.card-header
        p.card-header-title {{gettext('Finance account')}} # {{account.id}}
      .card-content
        table.table.is-fullwidth
          thead
            tr
              th {{gettext('Balance')}}
              th
          tbody
            tr
              th {{gettext('Amount')}}
              td {{account.amount}} &euro;
      footer.card-footer
        a.card-footer-item(@click="topUpModal = true") {{gettext('Top Up')}}
    v-modal(:show.sync="topUpModal" :clickAway="false")
      section.modal-card-body.top-up-modal
        .is-size-4.has-text-centered.title {{ gettext('Please, enter payment amount.') }}
        .field.is-horizontal
          label.label.name {{ gettext('Amount') }}
          .field-body
            input.input(
              type="number"
              :min="topUp.min"
              :max="topUp.max"
              v-model="topUp.amount"
              :class="{'is-danger': $v.topUp.amount.$error}"
              @input="$v.topUp.amount.$touch")
        .btn-wrap
          button.main-btn.col-white.bg-red.nav-item.is-tab(:disabled="formInvalid" @click="createTopUp") {{ gettext('Create invoice') }}
          button.main-btn.col-white.bg-black.nav-item.is-tab(@click="topUpModal = false") {{ gettext('Cancel') }}
</template>
<script>
import Vue from 'vue'
import { gettext, interpolate, ngettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import VModal from '@/components/modal'
import Vuelidate from 'vuelidate'
import { minValue, maxValue, required } from 'vuelidate/lib/validators'
const _ = require('lodash')

Vue.use(Vuelidate)

export default {
  name: 'FinanceAccount',
  components: {
    VModal
  },
  data () {
    return {
      account: {},
      topUpModal: false,
      topUp: {
        amount: 0,
        min: 50,
        max: 0
      }
    }
  },
  validations () {
    return {
      topUp: {
        amount: {
          minValue: minValue(this.topUp.min),
          maxValue: maxValue(this.topUp.max),
          required
        }
      }
    }
  },
  methods: {
    gettext: gettext,
    interpolate: interpolate,
    ngettext: ngettext,
    ...mapActions([
      'getFinanceAccountDetail',
      'getCvServiceItems',
      'createInvoiceTopUp'
    ]),
    loadServicesInfo () {
      this.getCvServiceItems(this.getLanguage).then(res => {
        this.topUp.amount = parseFloat((_.maxBy(res, i => parseFloat(i.price))).price).toFixed(2)
        this.topUp.max = (this.topUp.amount * 10)
      })
    },
    createTopUp () {
      this.createInvoiceTopUp({
        lang: this.getLanguage,
        account: this.account.id,
        amount: parseFloat(this.topUp.amount).toFixed(2).toString()
      }).then(res => {
        this.$router.push({name: 'Invoice', params: {lang: this.getLanguage}, query: {id: res.invoice_id}})
      })
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    formInvalid: function () {
      return this.$v.$invalid
    }
  },
  watch: {
    topUpModal: function (val) {
      if (val) this.loadServicesInfo()
    }
  },
  created () {
    this.getFinanceAccountDetail(this.getLanguage).then(res => {
      this.account = res
    })
  }
}
</script>
<style lang="scss">
  .finance-account {
    .card-content{
      padding: .5rem;
    }
    .card-header-title{
      justify-content: center;
    }
    .top-up-modal {
      .field {
        &.is-horizontal {
          align-items: center;
          .label{
            margin: 0 10px 0 0;
          }
          .field-body {
            input {
              border: 1px solid #dbdbdb;
              &.is-danger {
                border: 1px solid #c60733;
              }
            }
          }
          p.error {
            color: #c60733;
            font-size: small;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/billing/cabinet/parts/finance-account/index.vue